import { render } from "./TextSection.vue?vue&type=template&id=a7b90c98"
import script from "./TextSection.vue?vue&type=script&lang=js"
export * from "./TextSection.vue?vue&type=script&lang=js"

import "./TextSection.vue?vue&type=style&index=0&id=a7b90c98&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__